import { useState } from "react";
import { Helmet } from "react-helmet";
import { toast } from 'react-hot-toast';
import { Link } from "react-router-dom";

import ButtonLoader from './ButtonLoader';

import AseLogo from '../assets/ase-logo.png';
import { ArrowUturnLeftIcon } from '@heroicons/react/24/outline';

import authService from '../services/authService';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      await authService.createForgotPasswordRequest({
        userEmail: email
      });

      toast.success('Password reset link sent to your email');
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong, please try again');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center flex-grow min-h-screen px-2">
      <Helmet>
        <title>Forgot Password | ASE Group</title>
      </Helmet>

      <img src={AseLogo} alt="ASE Group" className='h-[50px] mb-10' />

      <div className='flex flex-col items-center justify-center min-w-full'>
        <form className='border border-gray-300 rounded-lg flex flex-col gap-4 w-full md:w-[550px] p-[32px] mb-4 shadow-md bg-white' onSubmit={handleSubmit}>
          <label className='flex flex-col gap-1'>
            <span>Your email</span>

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <button
            type="submit"
            className="w-full bg-ase-blue font-semibold text-white h-[48px] rounded-md flex items-center justify-center cursor-pointer"
            disabled={!email}
          >
            {isLoading ? <ButtonLoader /> : 'Request password reset'}
          </button>

          <div className="flex items-center justify-center gap-1 mt-1">
            <ArrowUturnLeftIcon className="h-5 w-5 text-ase-blue" />
            <Link to="/login" className="text-ase-blue">Back to login</Link>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ForgotPassword;
